import React, { memo } from "react";
import useEventsToolbar from "./index.hooks";
import {
  GridColumnsToolbarButton,
  GridFilterToolbarButton,
  GridToolbarContainer,
} from "@material-ui/data-grid";
import { AppButton } from "components";
import AddIcon from "@material-ui/icons/Add";
import { Hidden, Tooltip, Typography } from "@material-ui/core";

type EventsToolbarProps = {};

const EventsToolbar = ({}: EventsToolbarProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    handleCreateEventDialogOpen,
    data,
    isLoading,
  } = useEventsToolbar();

  // This toolbar lets the User add and filter events.
  // When in Desktop, the user can also toggle different columns.
  return (
    <GridToolbarContainer>
      <Tooltip
        title={<Typography variant={"body2"}>{data.message}</Typography>}
        placement={"bottom-start"}
        disableHoverListener={!data.isDisabled}
      >
        <span>
          <AppButton
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            className={styles.datagridButton}
            onClick={handleCreateEventDialogOpen}
            disabled={isLoading || data.isDisabled}
            loading={isLoading}
          >
            Nuovo
          </AppButton>
        </span>
      </Tooltip>
      <Hidden xsDown implementation="css">
        <GridColumnsToolbarButton />
      </Hidden>
      <GridFilterToolbarButton />
    </GridToolbarContainer>
  );
};

export default memo(EventsToolbar);
